import {DatePicker as DesktopDatePicker, Grid} from "antd";
import {DatePicker as MobileDatePicker} from "antd-mobile";
import React from "react";
import dayjs from "dayjs";
import {Button, Space} from "antd";
import {CalendarOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

const { useBreakpoint } = Grid;

/**
 * Universal component Date/Time
 * - on mobile: antd-mobile
 * - on desktop: ants DatePicker
 *
 * Props:
 * - value: dayjs|null current value
 * - onChange: (dayjs|null) => void
 * - placeholder?: string
 * - minDate?: Date
 * - maxDate?: Date
 * - disabledDate?: (currentDayjs) => boolean
 * - style?: React.CSSProperties
 */

export default function ResponsiveDateTimePicker({
                                                     value,
                                                     onChange,
                                                     placeholder = "Select date & time",
                                                     minDate,
                                                     maxDate,
                                                     disabledDate,
                                                     style,
                                                 }) {
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const {t} = useTranslation();

    const [open, setOpen] = React.useState(false);

    if (isMobile) {
        //Mobile
        return (
            <>
                <Button
                    block
                    icon={<CalendarOutlined />}
                    onClick={() => setOpen(true)}
                    style={style}
                >
                    {value ? value.format("DD.MM.YYYY HH:mm") : placeholder}
                </Button>

                <MobileDatePicker
                    visible={open}
                    onClose={() => setOpen(false)}
                    precision="minute"
                    value={value ? value.toDate() : undefined}
                    confirmText="Ok"
                    cancelText={t("functions.close")}
                    min={minDate}
                    max={maxDate}
                    onConfirm={(date) => {
                        setOpen(false);
                        onChange?.(date ? dayjs(date) : null);
                    }}
                    onCancel={() => setOpen(false)}
                />
            </>
        );
    }

    // Desktop
    return (
        <DesktopDatePicker
            showTime
            value={value}
            onChange={(d) => onChange?.(d || null)}
            placeholder={placeholder}
            disabledDate={disabledDate}
            style={{ width: "100%", ...style }}
        />
    );
}
